import {
  Component,
  OnInit,
  AfterViewInit,
  Optional,
  Input,
  ViewChild,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ElementRef,
  OnDestroy
} from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import {
  ControlContainer,
  FormControl,
  AbstractControl,
  FormGroup
} from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { ISupplierBasePriceScheme } from "src/app/cards/product/product-pricelist/product-pricelist.model";
import { Observable, of, forkJoin, Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
import {
  ProductPricelistService,
  OfferService,
  AuthenticationService,
  ProductService
} from "src/app/_services";
import { numberUtil } from "src/app/util/number-util";
import {
  calculateMargin,
  calculateSalePriceByDiscount,
  calculateDiscount as calculateListPriceDiscount,
  calculateUnitPrice
} from "src/app/_helpers/calculate";
import { MatTable } from "@angular/material/table";
import {
  OfferType,
  OfferProductStatus,
  OfferKind,
  CampaignTypeValueType,
  CampaignTypeVatType,
  SupplierOfferStatus,
  SupplierProductAssortmentStatus,
  SupplierProductAssortmentDeliveryStatus
} from "src/app/enum";
import {
  ICampaignTypeDto,
  IOfferCard,
  IOfferCardFormData
} from "src/app/models";
import { LxmDialog, LxmMessage } from "src/app/_helpers";
import { appSettings } from "src/app/app.settings";
import moment from "moment";
import { environment } from "src/environments/environment";
import { ContentLanguage } from "src/app/_helpers/content-language";
import { nullIfUndefined } from "src/app/util/fn";
import { IClvDto } from "src/app/cards/product/product-info/product-info.model";
import { PriceValuePipe } from "src/app/pipes";
import { OfferProductProcurementDetailDialogComponent } from "../dialog/offer-product-procurement-detail/offer-product-procurement-detail.dialog";
import {
  CdkDrag,
  CdkDragDrop,
  CdkDropList,
  moveItemInArray
} from "@angular/cdk/drag-drop";
import { OfferProductOrderDetailDialogComponent } from "../dialog/offer-product-order-detail/offer-product-order-detail.dialog";
import { CampaignDiscountMethod } from "src/app/enum/campaign-discount-method";
import { ProductPriceChangesInfoDialogComponent } from "../dialog/offer-product-price-changes/offer-product-price-changes.dialog";
import { ProductCampaignInfoDialogComponent } from "../dialog/supplier-offer-product-campaign/supplier-offer-product-campaign.dialog";
import { OfferProductsListBase } from "../offer-products-list-base";
import { OfferProductReplacementDialog } from "../dialog/offer-product-replacement/offer-product-replacement.dialog";
import { CalendarGroupCampaignType } from "src/app/enum/calendar-group-campaign-type";
import { SelectComponent } from "src/app/components/form/select/select.component";

@Component({
  selector: "supplier-offer-products-list",
  templateUrl: "./supplier-offer-products.component.html",
  styleUrls: ["../offer-products.component.scss", "./supplier-offer-table.scss"]
})
export class SupplierOfferProductsListComponent
  extends OfferProductsListBase
  implements OnInit, AfterViewInit, OnChanges, OnDestroy
{
  private destroy$ = new Subject<void>();
  private _subscriptions: Subscription[] = [];
  private _boundFormGroups = new WeakSet<AbstractControl>();
  private static _cols = [
    "drag",
    "product_image",
    "offer_product_name",
    "offer_product_available_from",
    "offer_product_internal_price",
    "offer_product_list_price",
    // "offer_product_list_and_client_price",
    "offer_product_price_discount",
    "offer_product_price_retailer",
    "offer_product_requested_price",
    // 'offer_product_offer_margin',
    "offer_product_recommended_retail_price",
    // 'offer_product_order_settings',
    "actions"
  ];

  private static _colsRPim = [
    //'offer_product_expander',
    "replacement_indicator",
    "drag",
    "product_image",
    "offer_product_name",
    "offer_product_available_from",
    "offer_product_internal_price",
    // "offer_product_list_price",
    "offer_product_list_and_client_price",
    "offer_product_price_discount",
    "offer_product_price_retailer",
    "offer_product_requested_price",
    // 'offer_product_offer_margin',
    "offer_product_recommended_retail_price",
    "product_replacement",
    "product_suspension",
    "actions"
  ];

  private static _procurementCols = [
    //'offer_product_expander',
    "drag",
    "product_image",
    "offer_product_name",
    "offer_product_internal_price",
    "offer_product_list_price",
    // "offer_product_list_and_client_price",
    "offer_product_price_discount",
    "offer_product_price_retailer",
    "offer_product_requested_price",
    // 'offer_product_offer_margin',
    "offer_product_recommended_retail_price",
    "offer_product_procurement_note",
    // 'offer_product_order_settings',
    "actions"
  ];

  private static _campaignCols = [
    //'offer_product_expander',
    "drag",
    "product_image",
    "offer_product_name",
    // "offer_product_display",
    "offer_product_price_valid_from_campaign",
    "offer_product_internal_price",
    "offer_product_list_and_client_price",
    // "offer_product_self_and_list_price_campaign",
    "offer_product_main_assortment_price_campaign",
    "offer_product_price_discount_campaign",
    "offer_product_price_retailer_campaign",
    "offer_product_recommended_retail_price",
    "offer_product_campaign_retail_price_info",
    "offer_campaign",
    // 'offer_product_order_settings',
    "actions"
  ];

  private static _campaignWithTypesCols = [
    "drag",
    "product_image",
    "offer_product_name",
    "offer_product_price_valid_from_campaign",
    "offer_product_campaign_type",
    "offer_product_current_price",
    "offer_product_campaign_discount_price_agreement",
    "offer_product_campaign_retail_price_discount",
    "offer_product_recommended_retail_price",
    "offer_product_campaign_retail_price_info",
    "offer_campaign",
    "actions"
  ];

  private static _logisticsCols = [
    //'offer_product_expander',
    "drag",
    "product_image",
    "offer_product_name",
    "offer_product_available_from",
    "offer_product_segment",
    "offer_product_storage_conditions",
    "offer_product_transport_unit_ean",
    "offer_product_pallet_type",
    // 'offer_product_order_settings',
    "actions"
  ];

  private static _priceChangesCols = [
    "drag",
    "product_image",
    "offer_product_name",
    "offer_product_price_change_date",
    "offer_product_current_price",
    "offer_product_editable_list_price",
    "offer_product_price_discount_price_changes",
    "offer_product_price_retailer_with_markup",
    // 'offer_product_price_retailer_with_markup_margin',
    "offer_product_requested_price",
    "offer_product_price_change_reason",
    "offer_product_price_change_note",
    "actions"
  ];

  public anyPriceValueChanged: boolean;
  public priceChangeReasons: IClvDto[];
  public dragDisabled = false;
  public campaignDiscountMethod: CampaignDiscountMethod;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild("table") table: MatTable<any>;

  @Output() onSort = new EventEmitter();

  protected get _defaultItem(): any {
    return SupplierOfferProductDefaultItem;
  }

  public OfferType = OfferType;

  @Input() public productAcExcludeIds: string[] = [];

  @Input() public offerStatus: SupplierOfferStatus;
  @Input() public offerId: string;
  @Input() public date: Date;
  @Input() public retailerId: string;
  @Input() public retailerHasRPim = false;
  @Input() public currency: IClvDto;
  @Input() public offerType: OfferType;
  @Input() public countryCode: string;
  @Input() public readonly = true;
  @Input() public canAddProducts = true;
  @Input() public softDelete = false;
  @Input() public showTotal = true;
  @Input() public showNoContentText = true;
  @Input() public canOrder = false;
  @Input() public campaignType: CalendarGroupCampaignType;
  @Input() public campaignTypes: ICampaignTypeDto[];
  @Input() public procurementId: string;

  public addProductLoading = false;
  public newProductAcLoading = false;

  public expandedElements = [];
  public expanders = [];

  public get columns(): string[] {
    switch (this.offerType) {
      case OfferType.MainAssortment:
        if (this.retailerHasRPim) {
          return SupplierOfferProductsListComponent._colsRPim;
        }
        return SupplierOfferProductsListComponent._cols;
      case OfferType.Campaign:
        if (
          this.campaignType ==
          CalendarGroupCampaignType.RetailSalesPriceDiscount
        ) {
          return SupplierOfferProductsListComponent._campaignWithTypesCols;
        }
        return SupplierOfferProductsListComponent._campaignCols;
      case OfferType.Logistics:
        return SupplierOfferProductsListComponent._logisticsCols;
      case OfferType.PriceChanges:
        return SupplierOfferProductsListComponent._priceChangesCols;
      case OfferType.Procurement:
        return SupplierOfferProductsListComponent._procurementCols;
    }
  }

  constructor(
    private _cd: ChangeDetectorRef,
    route: ActivatedRoute,
    private _router: Router,
    private _dialog: LxmDialog,
    private _offerService: OfferService,
    private _pricesService: ProductPricelistService,
    private _message: LxmMessage,
    private _authService: AuthenticationService,
    public contentLanguage: ContentLanguage,
    private _productsService: ProductService,
    @Optional() controlContainer: ControlContainer,
    private _priceValuePipe: PriceValuePipe
  ) {
    super(controlContainer, contentLanguage);

    // this._cd.detach();

    let formData = route.snapshot.data.formData as IOfferCardFormData;
    const offerCard = route.snapshot.data.offerCard as IOfferCard;
    if (offerCard) {
      this.anyPriceValueChanged = offerCard.anyPriceValueChanged;
      this.offerId = offerCard.offerDetail.id;
      formData = offerCard.formData;
    }

    if (formData) {
      this.priceChangeReasons = formData.priceChangeReasons;
      this.campaignDiscountMethod = formData.campaignDiscountMethod;
    }
  }

  ngAfterViewChecked(): void {
    if (this.table) {
      this.table.updateStickyColumnStyles();
    }
  }

  public ngOnInit(): void {
    super.ngOnInit();
    this._supplierOfferProductsListComponentInit();
  }

  public ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this._bindCalculations();
    // this._cd.detach();
    // this._cd.detectChanges();
  }

  public ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    const dateChanged =
      changes?.date &&
      changes.date.previousValue?.toISOString() !==
        changes.date.currentValue?.toISOString();
    const countryCodeChanged =
      changes?.countryCode &&
      changes.countryCode.previousValue !== changes.countryCode.currentValue;
    const retailerIdChanged =
      changes?.retailerId &&
      changes.retailerId.previousValue !== changes.retailerId.currentValue;
    const currencyChanged =
      changes?.currency &&
      changes.currency.previousValue?.id !== changes.currency.currentValue?.id;
    const offerTypeChanged =
      changes?.offerType &&
      changes.offerType.previousValue !== changes.offerType.currentValue;
    if (currencyChanged) {
      if (this._arr) {
        for (let i = 0; i < this._arr.length; i++) {
          this._arr.controls[i].get("salePrice").setValue(null);
        }

        if (this.offerType == OfferType.PriceChanges) {
          for (let i = 0; i < this._arr.length; i++) {
            this._arr.controls[i].get("editableListPrice").setValue(null);
          }
        }
      }
    }

    if (
      dateChanged ||
      countryCodeChanged ||
      retailerIdChanged ||
      currencyChanged ||
      offerTypeChanged
    ) {
      const productIds = this.dataSource.data.map((x) => x.value.productId);
      this._updatePrices(productIds);

      if (dateChanged) {
        this._updateCampaignPriceValidFromDates();
        this._updatePriceChangeDates();
      }

      if (dateChanged || retailerIdChanged) {
        this._updateOfferProductRelations(productIds);
      }
    }

    if (
      this.dataSource.data.length &&
      (retailerIdChanged || offerTypeChanged || dateChanged)
    ) {
      const productIds = this.dataSource.data.map((x) => x.value.productId);

      let productsWithDisplayObservable = of({});
      let productsWithOrderUnitsObservable = of({});
      let productLogisticsDataObservable = of({});
      let productValidityObservable = of({});
      let productsInRecentCampaignObservable = of({});

      if (this.retailerId) {
        if (retailerIdChanged || offerTypeChanged || dateChanged) {
          if (this.offerType === OfferType.Logistics) {
            productLogisticsDataObservable = this._offerService.logisticsData(
              productIds,
              this.retailerId
            );
          } else {
            productsWithDisplayObservable =
              this._offerService.productsWithDisplay(
                productIds,
                this.retailerId
              );
            productsWithOrderUnitsObservable =
              this._offerService.productsWithOrderUnits(
                productIds,
                this.retailerId
              );
          }
          productValidityObservable =
            this._productsService.getProductsValidState(productIds, [
              this.retailerId
            ]);

          if (this.offerType === OfferType.Campaign) {
            if (this.date) {
              let req = {
                productIds: productIds,
                retailerId: this.retailerId,
                dateFrom: this.date
              };

              if (this.offerId) {
                Object.assign(req, { offerId: this.offerId });
              }

              productsInRecentCampaignObservable =
                this._offerService.productsInRecentCampaign(req);
            }
          }
        }
      }

      forkJoin([
        productsWithDisplayObservable,
        productLogisticsDataObservable,
        productValidityObservable,
        productsInRecentCampaignObservable,
        productsWithOrderUnitsObservable
      ]).pipe(takeUntil(this.destroy$)).subscribe((results) => {
        const productsWithDisplay = results[0];
        const logisticsData = results[1];
        const validStates = results[2];
        const productsInRecentCampaign = results[3];
        const productsWithOrderUnits = results[4];

        const arr = this.dataSource.data;

        for (let i = 0; i < arr.length; i++) {
          const productId = arr[i].value.productId;

          let patch = {
            productHasDisplay: nullIfUndefined(
              productsWithDisplay?.[productId]
            ),
            display: productsWithDisplay[productId] ? true : false,
            segment: nullIfUndefined(logisticsData[productId]?.segment),
            storageConditions: nullIfUndefined(
              logisticsData[productId]?.storageConditions
            ),
            storageMinTemp: nullIfUndefined(
              logisticsData[productId]?.storageMinTemp
            ),
            storageMaxTemp: nullIfUndefined(
              logisticsData[productId]?.storageMaxTemp
            ),
            transportUnitDefaultEan: nullIfUndefined(
              logisticsData[productId]?.transportUnitDefaultEan
            ),
            palletType: nullIfUndefined(logisticsData[productId]?.palletType),
            isValid: validStates[productId]?.[this.retailerId || ""] ?? true
            ,
            isInRecentCampaign: nullIfUndefined(
              productsInRecentCampaign?.[productId]
            ),
            isOrderUnitMissing: productsWithOrderUnits[productId] === false,
          };

          arr[i].patchValue(patch);
        }
      });
    }

    if (this.table) {
      // Fix sticky columns on readonly change
      setTimeout((_) => {
        this.table.updateStickyColumnStyles();
        this.table.renderRows();
      });
    }
  }

  public getRowInvalidTypeString(rowValue: any): string {
    const { retailer } = this.formGroup.value || {};

    if (
      (retailer && retailer.hasMandatoryProductValidation) ||
      this._rowHasMissingPrices(rowValue)
    ) {
      return "warningRed";
    }

    return "warning";
  }

  private _rowHasMissingPrices(rowValue: any): boolean {
    const { retailer, dateFrom } = this.formGroup.value;

    if (!dateFrom || !retailer) {
      return false;
    }

    const listPriceRequiredOfferTypes = [
      OfferType.MainAssortment,
      OfferType.Campaign
    ];
    const listPriceRequired = listPriceRequiredOfferTypes.includes(
      this.offerType
    );

    if (listPriceRequired) {
      const listPrice = this.getListPrice(rowValue);
      const mainAssortmentPrice = this.getMainAssortmentPrice(rowValue);
      if (!listPrice && !mainAssortmentPrice) {
        return true;
      }
    }
    return false;
  }

  public isRowInvalid(rowValue: any): boolean {
    if (this.isRowDeletedOrRemoved(rowValue) 
      || this.isRowReplaced(rowValue) 
      || this.isRowSuspended(rowValue)
      || this.isRowRejected(rowValue)) {
      return false;
    }

    const { retailer } = this.formGroup.value || {};

    if (!retailer) {
      return false;
    }

    if (this._rowHasMissingPrices(rowValue)) {
      return true;
    }

    return !rowValue.isValid;
  }

  public get getProductAcExcludeIds() {
    return this.dataSource.data.map((x) => x.value.productId);
  }

  dropTable(event: CdkDragDrop<string[]>) {
    if (this.readonly) {
      return;
    }

    moveItemInArray(
      this.dataSource.data,
      event.previousIndex,
      event.currentIndex
    );
    this.onSort.emit(true);
    this._arr.updateValueAndValidity({ onlySelf: true });
    this.table.renderRows();
  }

  private _supplierOfferProductsListComponentInit() {
    const newProductAc = new FormControl();
    this.fgInternal.addControl("newProduct", newProductAc);

    this._subscriptions.push(
      newProductAc.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((x) => {
      if (x) {
        var productId = x.id;

        this.addProductLoading = true;

        let basePricesObservable: Observable<any> = of({});
        let productsWithDisplayObservable: Observable<any> = of({});
        let productsWithOrderUnitsObservable: Observable<any> = of({});
        let productsInRecentCampaignObservable: Observable<any> = of({});
        let productLogisticsDataObservable: Observable<any> = of({});
        let productValidityObservable: Observable<any> = of({});
        let retailerProductPricesObservable: Observable<any> = of({});
        let offerProductRelationsObservable: Observable<any> = of({});
        let productInOtherProcurementItemObservable: Observable<any> = of(false);

        if (this.retailerId) {

          productValidityObservable =
            this._productsService.getProductsValidState(
              [productId],
              [this.retailerId]
          );

          if (this.offerType === OfferType.Logistics) {
            productLogisticsDataObservable = this._offerService.logisticsData(
              [productId],
              this.retailerId
            );
          } else {
            basePricesObservable = this._getBasePrices([productId]);
            productsWithDisplayObservable =
              this._offerService.productsWithDisplay(
                [productId],
                this.retailerId
              );
            productsWithOrderUnitsObservable =
              this._offerService.productsWithOrderUnits(
                [productId],
                this.retailerId
              );
            if (this.offerType === OfferType.Campaign) {
              if (this.date) {
                let req = {
                  productIds: [productId],
                  retailerId: this.retailerId,
                  dateFrom: this.date
                };
                if (this.offerId) {
                  Object.assign(req, {
                    offerId: this.offerId
                  });
                }
                productsInRecentCampaignObservable =
                  this._offerService.productsInRecentCampaign(req);
              }
            }

            if (this.offerType === OfferType.PriceChanges) {
              if (this.date && (this.offerId || this.retailerId)) {
                offerProductRelationsObservable =
                  this._offerService.getOfferProductRelations(
                    [productId],
                    this.date,
                    this.offerId,
                    this.retailerId
                  );
              }
            }

            if (this.offerType === OfferType.Procurement) {
              if (this.procurementId && this.procurementItemId) {
                productInOtherProcurementItemObservable = this._offerService.isProductInOtherProcurementItem(
                  productId,
                  this.procurementId,
                  this.procurementItemId
                );
              }
            }

            if (
              this.campaignType ==
                CalendarGroupCampaignType.RetailSalesPriceDiscount &&
              this.date
            ) {
              retailerProductPricesObservable =
                this._pricesService.getRetailerProductPrices(
                  this.retailerId,
                  this.date,
                  [productId]
                );
            }
          }

        }

        forkJoin([
          basePricesObservable,
          productsWithDisplayObservable,
          productLogisticsDataObservable,
          productValidityObservable,
        offerProductRelationsObservable,
        retailerProductPricesObservable,
        productsInRecentCampaignObservable,
        productsWithOrderUnitsObservable,
        productInOtherProcurementItemObservable
      ]).pipe(takeUntil(this.destroy$)).subscribe((results) => {
          const basePrices = results[0];
          const productsWithDisplay = results[1];
          const logisticsData = results[2];
          const validState = results[3];
          const offerProductRelations = results[4];
          const retailerProductPrices = results[5];
          const productsInRecentCampaign = results[6];
          const productsWithOrderUnits = results[7];
          const isProductInOtherProcurementItem = results[8];

          let item = {
            productId: productId,
            productHasDisplay: productsWithDisplay[productId],
            isInRecentCampaign: productsInRecentCampaign[productId],
            isInOtherProcurementItem: isProductInOtherProcurementItem,
            name: x.name,
            ean: x.ean,
            contentUnitId: x.contentUnitId,
            supplierCode: x.supplierCode,
            assortmentDeliveryStatus: x.assortmentDeliveryStatus,
            assortmentStatus: basePrices[productId]?.status,
            brand: { id: x.brand?.id, value: x.brand?.value },
            selfPrice: basePrices[productId]?.buyInPrice,
            calculatedSelfPriceInForeignCurrency:
              basePrices[productId]?.calculatedBuyInPriceInForeignCurrency,

            listPrice: basePrices[productId]?.publicSalesPrice,
            salePrice:
              basePrices[productId]?.mainAssortmentPrice ||
              basePrices[productId]?.publicSalesPrice,
            vat: basePrices[productId]?.vat,
            mainAssortmentPrice:
              basePrices[productId]?.mainAssortmentPrice ||
              basePrices[productId]?.publicSalesPrice,
            imageUrl: x.hasImage
              ? `${environment.apiUrl}api/products/${productId}/images/thumbnailMedium`
              : null,

            segment: logisticsData[productId]?.segment,
            storageConditions: logisticsData[productId]?.storageConditions,
            transportUnitDefaultEan:
              logisticsData[productId]?.transportUnitDefaultEan,
            storageMinTemp: logisticsData[productId]?.storageMinTemp,
            storageMaxTemp: logisticsData[productId]?.storageMaxTemp,
            palletType: logisticsData[productId]?.palletType,

            mainAssortmentCurrency:
              basePrices[productId]?.mainAssortmentCurrency,
            mainAssortmentListPrice:
              basePrices[productId]?.mainAssortmentListPrice,
            discountPriceChanges: null,
            priceChangesInfo: null,

            isNew: true,
            isValid: validState[productId]?.[this.retailerId || ""],
            isOrderUnitMissing: productsWithOrderUnits[productId] === false,

            campaignType: null,
            discountCampaignWithType: null,
            validRetailerProductBuyInPriceScheme:
              retailerProductPrices[productId]
          };

          if (this.offerType == OfferType.PriceChanges) {
            item.listPrice = basePrices[productId]?.publicSalesPrice;
            item.mainAssortmentPrice =
              basePrices[productId]?.mainAssortmentPrice;
            item.mainAssortmentListPrice =
              basePrices[productId]?.mainAssortmentListPrice;
            item.mainAssortmentCurrency =
              basePrices[productId]?.mainAssortmentCurrency;
            item.discountPriceChanges =
              basePrices[productId]?.defaultDiscountPercent;
            item.priceChangesInfo = {
              priceChangeDate: { editableDate: this.date },
              activeCampaignPriceSchemes: nullIfUndefined(
                offerProductRelations?.activeCampaignPriceSchemes?.[productId]
              ),
              activeOffers: nullIfUndefined(
                offerProductRelations?.activeOffers?.[productId]
              )
            };
          }

          this.addProductLoading = false;
          this.addItem(item);

          this._bindCalculations();
          if (basePrices[productId]?.defaultDiscountPercent) {
            this.dataSource.data[this.dataSource.data.length - 1]
              .get("discount")
              .setValue(basePrices[productId]?.defaultDiscountPercent);
          }
        });
        newProductAc.setValue(null);
      }
    }));
  }

  private _updatePrices(productIds: string[]) {
    const basePrices = this._getBasePrices(productIds);
    this._subscriptions.push(
      basePrices.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      const arr = this.dataSource.data;
      for (let i = 0; i < arr.length; i++) {
        const productId = arr[i].value.productId;
        if (!res.hasOwnProperty(productId)) {
          continue;
        }

        const priceScheme = res[productId];
        if (!priceScheme) {
          continue;
        }

        let patch = {
          assortmentStatus: nullIfUndefined(priceScheme.status),
          selfPrice: nullIfUndefined(priceScheme.buyInPrice),
          calculatedSelfPriceInForeignCurrency: nullIfUndefined(
            priceScheme.calculatedBuyInPriceInForeignCurrency
          ),
          listPrice: nullIfUndefined(priceScheme.publicSalesPrice),
          vat: nullIfUndefined(priceScheme.vat),
          discount: nullIfUndefined(priceScheme.defaultDiscountPercent),
          mainAssortmentPrice: nullIfUndefined(
            priceScheme.mainAssortmentPrice || priceScheme.publicSalesPrice
          ),
          mainAssortmentListPrice: nullIfUndefined(
            priceScheme.mainAssortmentListPrice
          ),
          mainAssortmentCurrency: nullIfUndefined(
            priceScheme.mainAssortmentCurrency
          )
        };

        if (this.offerType == OfferType.PriceChanges) {
          Object.assign(patch, {
            discountPriceChanges: this.getPriceIfDefault(
              arr[i].get("discountPriceChanges"),
              priceScheme.defaultDiscountPercent
            ),
            editableListPrice: this.getPriceIfDefault(
              arr[i].get("editableListPrice"),
              priceScheme.publicSalesPrice
            )
          });
        }

        arr[i].patchValue(patch);
        this._cd.detectChanges();
      }
    }));
  }

  private _twoWayBinding(
    row: AbstractControl,
    sourceField: string,
    targetField: string,
    target: string | ((r: AbstractControl) => string),
    calcTarget: (x, y) => any,
    calcSource: (x, y) => any
  ): void {
    this._subscriptions.push(
      row.get(sourceField).valueChanges.pipe(takeUntil(this.destroy$)).subscribe((val) => {
      let sourceValue = numberUtil.toNumber(val);

      const targetControlName =
        typeof target === "string" ? target : target(row);

      let targetValue = numberUtil.toNumber(row.get(targetControlName).value);

      if (!numberUtil.isNumber(sourceValue)) {
        sourceValue = 0;
      }

      if (numberUtil.isNumber(targetValue)) {
        row.patchValue(
          {
            [targetField]: calcTarget(sourceValue, targetValue)
          },
          {
          emitEvent: false
        }
      );
      }
    }));

    this._subscriptions.push(
      row.get(targetField).valueChanges.pipe(takeUntil(this.destroy$)).subscribe((val) => {
      const targetControlName =
        typeof target === "string" ? target : target(row);

      let sourceValue = numberUtil.toNumber(row.get(targetControlName).value);
      let targetValue = numberUtil.toNumber(val);
      if (
        !numberUtil.isNumber(sourceValue) ||
        !numberUtil.isNumber(sourceValue)
      ) {
        return;
      }
      row.patchValue(
        {
          [sourceField]: calcSource(targetValue, sourceValue)
        },
        {
          emitEvent: false
        }
      );
    }));

    // this._cd.detectChanges();
  }

  public getListPrice(item) {
    if (this.offerType == OfferType.Campaign) {
      return (
        item.validSchemeMainAssortmentListPrice ||
        item.mainAssortmentListPrice ||
        item.validSchemeListPrice ||
        item.listPrice
      );
    }

    return item.validSchemeListPrice || item.listPrice;
  }

  public getMainAssortmentPrice(item) {
    return (
      item.validSchemeMainAssortmentPrice ||
      item.mainAssortmentPrice ||
      item.listPrice
    );
  }

  private _getValidListPriceControlName(
    c: AbstractControl,
    campaignDiscount = false
  ): string {
    let name = "";
    let value = null;

    if (
      this.offerType == OfferType.Campaign &&
      c.value.validSchemeMainAssortmentListPrice
    ) {
      if (campaignDiscount) {
        name =
          this.campaignDiscountMethod == CampaignDiscountMethod.FromNormalPrice
            ? "validSchemeMainAssortmentPrice"
            : "validSchemeMainAssortmentListPrice";
      }

      value = c.get(name)?.value;
      if (value && value > 0) {
        return name;
      }

      return "validSchemeMainAssortmentListPrice";
    } else if (
      this.offerType == OfferType.Campaign &&
      c.value.mainAssortmentListPrice
    ) {
      if (campaignDiscount) {
        name =
          this.campaignDiscountMethod == CampaignDiscountMethod.FromNormalPrice
            ? "mainAssortmentPrice"
            : "mainAssortmentListPrice";
      }

      value = c.get(name)?.value;
      if (value && value > 0) {
        return name;
      }

      return "mainAssortmentListPrice";
    } else if (c.value.validSchemeListPrice) {
      return "validSchemeListPrice";
    }

    if (this.offerType == OfferType.Campaign && campaignDiscount) {
      name =
        this.campaignDiscountMethod == CampaignDiscountMethod.FromNormalPrice
          ? "mainAssortmentPrice"
          : "listPrice";
    }

    value = c.get(name)?.value;
    if (value && value > 0) {
      return name;
    }

    return "listPrice";
  }

  private _bindCalculations(): void {
    const arr = this.dataSource.data;
    for (let i = 0; i < arr.length; i++) {
      if (this._boundFormGroups.has(arr[i])) {
        continue;
      }
      
      this._boundFormGroups.add(arr[i]);
      
      this._twoWayBinding(
        arr[i],
        "discount",
        "salePrice",
        (c) => this._getValidListPriceControlName(c),
        this.calculateSalePriceByDiscount,
        this.calculateDiscount
      );

      this._twoWayBinding(
        arr[i],
        "discountCampaign",
        "salePriceCampaign",
        (c) => this._getValidListPriceControlName(c, true),
        this.calculateSalePriceByDiscount,
        this.calculateDiscount
      );

      this._twoWayBinding(
        arr[i],
        "discountCampaignInput",
        "salePriceCampaignInput",
        (c) => this._getValidListPriceControlName(c, true),
        this.calculateSalePriceByDiscount,
        this.calculateDiscount
      );

      this._twoWayBinding(
        arr[i],
        "discountPriceChanges",
        "salePricePriceChanges",
        "editableListPrice",
        this.calculateSalePriceByDiscount,
        this.calculateDiscount
      );

      this._subscriptions.push(
        arr[i]?.get("priceChangeDate").valueChanges.pipe(takeUntil(this.destroy$)).subscribe((val) => {
        const date = val || this.date;
        const productId = arr[i].get("productId").value;

        const offerProductRelationsObservable =
          this.offerType == OfferType.PriceChanges &&
          date &&
          (this.offerId || this.retailerId)
            ? this._offerService.getOfferProductRelations(
                [productId],
                date,
                this.offerId,
                this.retailerId
              )
            : of({});

        this._subscriptions.push(
          offerProductRelationsObservable.pipe(takeUntil(this.destroy$)).subscribe((res) => {
          arr[i]
            .get("activeOffers")
            .setValue(nullIfUndefined(res?.activeOffers?.[productId]));
          arr[i]
            .get("activeCampaignPriceSchemes")
            .setValue(
              nullIfUndefined(res?.activeCampaignPriceSchemes?.[productId])
            );
        }));
      }));

      this._subscriptions.push(
        arr[i].get("editableListPrice").valueChanges.pipe(takeUntil(this.destroy$)).subscribe((val) => {
        const discountValue = arr[i].get("discountPriceChanges").value;
        const discount = numberUtil.toNumber(discountValue);
        arr[i]
          .get("salePricePriceChanges")
          .setValue(this.calculateSalePriceByDiscount(discount, val));
      }));

      if (
        this.campaignType == CalendarGroupCampaignType.RetailSalesPriceDiscount
      ) {
        this._subscriptions.push(
          arr[i].get("discountCampaignWithType").valueChanges.pipe(takeUntil(this.destroy$)).subscribe((val) => {
          const sourceValue = numberUtil.toNumber(val);

          const validPrice = this.getValidRetailerProductBuyInPriceScheme(
            arr[i]?.value
          );
          const selectedCampaignType = arr[i].get("campaignType").value;
          const { vatType, valueType } = selectedCampaignType || {};

          const price =
            vatType == CampaignTypeVatType.WithVat
              ? validPrice?.price
              : validPrice?.priceWithoutVat;
          if (!price) {
            return;
          }

          const discountedPrice =
            valueType == CampaignTypeValueType.Value
              ? price - sourceValue
              : price - (price * sourceValue) / 100;
          arr[i]
            .get("suggestedRetailPrice")
            .setValue(discountedPrice, { emitEvent: false });
        }));

        this._subscriptions.push(
          arr[i].get("suggestedRetailPrice").valueChanges.pipe(takeUntil(this.destroy$)).subscribe((val) => {
          const sourceValue = numberUtil.toNumber(val);
          const validPrice = this.getValidRetailerProductBuyInPriceScheme(
            arr[i]?.value
          );
          const selectedCampaignType = arr[i].get("campaignType").value;
          const discount = this._getDiscountCampaignWithType(
            selectedCampaignType,
            validPrice,
            sourceValue
          );

          arr[i]
            .get("discountCampaignWithType")
            .setValue(discount, { emitEvent: false });
        }));
      }
    }
  }

  ngOnDestroy() {
    this._subscriptions.forEach(sub => sub?.unsubscribe());
    this.destroy$.next();
    this.destroy$.complete();
  }

  public calculateSalePriceByDiscount(discount, listPrice) {
    return numberUtil.round(
      calculateSalePriceByDiscount(discount, listPrice),
      3
    );
  }

  public calculateListPriceDiscount(listPrice, assortmentPrice) {
    return calculateListPriceDiscount(assortmentPrice, listPrice);
  }

  public calculateCampaignDiscountMargin(row) {
    let price = this.getCampaignDiscountPrice(
      row.mainAssortmentPrice,
      row.mainAssortmentListPrice
    );
    return calculateMargin(row.salePriceCampaign, price);
  }

  public getCampaignDiscountPrice(normalPrice, priceListPrice) {
    return this.campaignDiscountMethod == CampaignDiscountMethod.FromNormalPrice
      ? normalPrice
      : priceListPrice;
  }

  private _updateCampaignPriceValidFromDates() {
    const arr = this.dataSource.data;
    for (let i = 0; i < arr.length; i++) {
      arr[i].get("campaignPriceValidFrom").setValue(this.date);
    }
    // this._cd.detectChanges();
  }

  private _updatePriceChangeDates() {
    const arr = this.dataSource.data;
    for (let i = 0; i < arr.length; i++) {
      let priceChangeDate = arr[i].get("priceChangeDate");
      if (!priceChangeDate.value) {
        priceChangeDate.setValue(this.date);
      }
    }
    // this._cd.detectChanges();
  }

  // Manually update prices on button click
  public updatePrices() {
    this._subscriptions.push(
      this._offerService.updatePrices(this.offerId).pipe(takeUntil(this.destroy$)).subscribe((res) => {
      const arr = this.dataSource.data;
      for (let i = 0; i < arr.length; i++) {
        const productId = arr[i].value.productId;
        if (!res.hasOwnProperty(productId)) {
          continue;
        }

        arr[i].get("validSchemeListPrice").setValue(null);
        arr[i].get("validSchemeMainAssortmentListPrice").setValue(null);
        arr[i].get("validSchemeMainAssortmentPrice").setValue(null);
        arr[i].get("validSchemeSelfPrice").setValue(null);
        arr[i]
          .get("validSchemeCalculatedSelfPriceInForeignCurrency")
          .setValue(null);

        arr[i].get("listPrice").setValue(res[productId]?.listPrice || null);
        arr[i]
          .get("mainAssortmentListPrice")
          .setValue(res[productId]?.mainAssortmentListPrice || null);
        arr[i]
          .get("mainAssortmentPrice")
          .setValue(res[productId]?.mainAssortmentPrice || null);
        arr[i].get("selfPrice").setValue(res[productId]?.selfPrice || null);
        arr[i]
          .get("calculatedSelfPriceInForeignCurrency")
          .setValue(
            res[productId]?.calculatedBuyInPriceInForeignCurrency || null
          );
      }
      this.anyPriceValueChanged = false;
      this._message.ok({
        message: "cards.offer.products.prices_updated"
      });
    }));

    // this._cd.detectChanges();
  }

  // private setPriceIfDefault(c: AbstractControl, val: number) {
  //   if (c.value) {
  //     let number = numberUtil.toNumber(c.value);
  //     if (number != 0) {
  //       return;
  //     }
  //   }

  //   c.setValue(val || null);
  //   // this._cd.detectChanges();
  // }

  private getPriceIfDefault(c: AbstractControl, val: number) {
    if (c.value) {
      let number = numberUtil.toNumber(c.value);
      if (number != 0) {
        return c.value;
      }
    }

    return val;
    // this._cd.detectChanges();
  }

  private _getBasePrices(
    productIds: string[]
  ): Observable<{ [productId: string]: ISupplierBasePriceScheme }> {
    return !this.retailerId ||
      !this.date ||
      !productIds.length ||
      !this.currency?.id
      ? of(Object.assign({}, ...productIds.map((x) => ({ [x]: null }))))
      : this._pricesService.getProductPrices(
          this.retailerId,
          this.date,
          productIds,
          this.currency?.id
        );
  }

  private _updateOfferProductRelations(productIds: string[]) {
    const offerProductRelationsObservable =
      this.offerType == OfferType.PriceChanges &&
      productIds.length &&
      this.date &&
      (this.offerId || this.retailerId)
        ? this._offerService.getOfferProductRelations(
            productIds,
            this.date,
            this.offerId,
            this.retailerId
          )
        : of({});

    offerProductRelationsObservable.subscribe((res) => {
      const arr = this.dataSource.data;
      for (let i = 0; i < arr.length; i++) {
        const productId = arr[i].get("productId").value;
        const activeOffers = nullIfUndefined(res?.activeOffers?.[productId]);
        const activeCampaignPriceSchemes = nullIfUndefined(
          res?.activeCampaignPriceSchemes?.[productId]
        );

        arr[i].get("activeOffers").setValue(activeOffers);
        arr[i]
          .get("activeCampaignPriceSchemes")
          .setValue(activeCampaignPriceSchemes);
      }
    });
  }

  public showProductInOtherProcurementItemRowError(row) {
    return (
      this.offerType === OfferType.Procurement &&
      row.value.isInOtherProcurementItem
    );
  }

  protected _getNormalizedItem(item: any, force = false) {
    if (item.isNormalized && !force) {
      return item;
    }

    return {
      id: item.id,
      productId: item.productId,
      preview: item.preview || {},
      campaignInfo: item.campaignInfo || {},
      name: this.contentLanguage.get(item.name),
      display: item.display || false,
      productHasDisplay: item.productHasDisplay || false,
      limit: item.limit || null,
      ean: item.ean,
      supplierCode: item.supplierCode,
      assortmentDeliveryStatus: item.assortmentDeliveryStatus,
      brand: item.brand?.value || null,
      availableFrom: item.availableFrom?.editableDate || null,
      campaignPriceValidFrom:
        item.campaignInfo?.campaignPriceValidFrom?.editableDate ||
        this.date ||
        moment(),
      selfPrice: item.selfPrice,
      calculatedSelfPriceInForeignCurrency:
        item.calculatedSelfPriceInForeignCurrency,
      listPrice: item.listPrice,
      salePrice: item.salePrice,
      salePriceCampaign: item.salePrice,
      discount: this.calculateDiscount(item.salePrice, this.getListPrice(item)),
      discountCampaign: this.calculateDiscount(
        item.salePrice,
        this.getCampaignDiscountPrice(
          this.getMainAssortmentPrice(item),
          this.getListPrice(item)
        )
      ),
      vat: item.vat,
      mainAssortmentPrice: item.mainAssortmentPrice,
      mainAssortmentListPrice: item.mainAssortmentListPrice,
      mainAssortmentCurrency: item.mainAssortmentCurrency,
      suggestedRetailPrice: item.suggestedRetailPrice,
      shops: item.shops || [],
      assortmentStatus: item.assortmentStatus,
      isDeleted: false,
      isNew: item.isNew || false,
      isNormalized: true,
      thumbnailUrl: item.thumbnailUrl,
      thumbnail: item.thumbnail,
      thumbnailContentType: item.thumbnailContentType,
      imageUrl: item.imageUrl,
      isInRecentCampaign: item.isInRecentCampaign || false,
      contentUnitId: item.contentUnitId,
      netContent: item.netContent,
      drainedWeightInGrams: item.drainedWeightInGrams,
      validSchemeSelfPrice: item.validSchemeSelfPrice,
      validSchemeCalculatedSelfPriceInForeignCurrency:
        item.validSchemeCalculatedSelfPriceInForeignCurrency,
      validSchemeListPrice: item.validSchemeListPrice,
      validSchemeMainAssortmentPrice: item.validSchemeMainAssortmentPrice,
      validSchemeMainAssortmentListPrice:
        item.validSchemeMainAssortmentListPrice,
      requestedPrice: item.requestedPrice,

      segment: nullIfUndefined(item.logisticsInfo?.segment),
      storageConditions: nullIfUndefined(item.logisticsInfo?.storageConditions),
      storageMinTemp: nullIfUndefined(item.logisticsInfo?.storageMinTemp),
      storageMaxTemp: nullIfUndefined(item.logisticsInfo?.storageMaxTemp),
      transportUnitDefaultEan: nullIfUndefined(
        item.logisticsInfo?.transportUnitDefaultEan
      ),
      palletType: nullIfUndefined(item.logisticsInfo?.palletType),

      priceChangeDate: nullIfUndefined(
        item.priceChangesInfo?.priceChangeDate?.editableDate
      ),
      priceChangeReason: nullIfUndefined(
        item.priceChangesInfo?.priceChangeReason
      ),
      priceChangeNote: nullIfUndefined(item.priceChangesInfo?.priceChangeNote),
      editableListPrice: item.listPrice,
      salePricePriceChanges: item.salePrice,
      discountPriceChanges:
        item.discountPriceChanges ||
        this.calculateDiscount(item.salePrice, item.listPrice),
      activeCampaignPriceSchemes: nullIfUndefined(
        item.priceChangesInfo?.activeCampaignPriceSchemes
      ),
      activeOffers: nullIfUndefined(item.priceChangesInfo?.activeOffers),

      orderDetails: item.orderDetails,
      isOrderUnitMissing: item.isOrderUnitMissing || false,
      procurementDetails: item.procurementDetails || {},
      isInOtherProcurementItem: item.isInOtherProcurementItem || false,

      status: item.status,
      isValid: item.isValid,
      isSuspended: item.isSuspended ?? false,
      replacementForProductId: item.replacementForProductId ?? null,

      campaignType: this.campaignTypes?.find(
        (x) => x.id == item.campaignTypeId
      ),
      discountCampaignWithType: this.getDiscountCampaignWithType(item),
      validRetailerProductBuyInPriceScheme:
        item.validRetailerProductBuyInPriceScheme,
      editCampaignSalePrice: false,
      discountCampaignInput: this.calculateDiscount(
        item.salePrice,
        this.getCampaignDiscountPrice(
          this.getMainAssortmentPrice(item),
          this.getListPrice(item)
        )
      ),
      salePriceCampaignInput: item.salePrice
    };
  }

  public setCampaignDiscountPriceAgreement(row: FormGroup) {
    let priceInputValue = row.controls["salePriceCampaignInput"].value;
    if (typeof priceInputValue === "string") {
      priceInputValue = parseFloat(priceInputValue?.replace(",", "."));
    }

    row.controls["salePriceCampaign"].setValue(priceInputValue);
    row.controls["editCampaignSalePrice"].setValue(false);
  }

  public discardCampaignDiscountPriceAgreement(row: FormGroup) {
    row.controls["salePriceCampaignInput"].setValue(
      row.controls["salePriceCampaign"].value
    );
    row.controls["editCampaignSalePrice"].setValue(false);
  }

  public getValidRetailerProductBuyInPriceScheme(item: any) {
    const buyInPriceScheme = item?.validRetailerProductBuyInPriceScheme;
    const retailPrices = buyInPriceScheme?.retailPrices;

    if (retailPrices) {
      return retailPrices[0];
    }

    return null;
  }

  public calculateCampaignWithTypesDiscountMargin(row) {
    const campaignDiscountPrice = this.getCampaignDiscountPrice(
      this.getMainAssortmentPrice(row),
      this.getListPrice(row)
    );
    return this.calculateMargin(row.salePriceCampaign, campaignDiscountPrice);
  }

  public campaignWithTypesDiscountPrice(row) {
    return this.getCampaignDiscountPrice(
      this.getMainAssortmentPrice(row),
      this.getListPrice(row)
    );
  }

  public removeItem(index: number) {
    if (this.softDelete) {
      const item = this._arr.controls[index] as FormGroup;
      const isNew = item.get("isNew").value;
      const status = item.get("status").value;
      const isReplaced = this.isRowReplaced(item);

      if (isReplaced) {
        const replacementProductIndexes = this.getRowReplacementIndexes(item);
        replacementProductIndexes.forEach((i) => {
          this._arr.removeAt(index);
        });
      }

      if (isNew) {
        this._arr.removeAt(index);
      } else {
        item
          .get("status")
          .patchValue(
            status === OfferProductStatus.Removed
              ? OfferProductStatus.Pending
              : OfferProductStatus.Removed
          );
      }

      this._updateTable();
    } else {
      const item = this._arr.controls[index] as FormGroup;
      const isReplaced = this.isRowReplaced(item);
      if (isReplaced) {
        const replacementProductIndexes = this.getRowReplacementIndexes(item);
        replacementProductIndexes.forEach((i) => {
          this._arr.removeAt(index);
        });
      }

      super.removeItem(index);
    }

    // this._cd.detectChanges();
  }

  public toggleExpandRow(row: any) {
    if (this.expandedElements.includes(row)) {
      const index = this.expandedElements.indexOf(row);
      this.expandedElements.splice(index, 1);
    } else {
      this.expandedElements.push(row);
    }
    // this._cd.detectChanges();
  }

  public productClick(productId: string, validate = false) {
    let url = this._router.createUrlTree(["/products", productId]).toString();

    if (validate) {
      url += "/validate";
    }

    window.open(window.location.origin + url, "_blank");
  }

  public hasExistingCampaignInfo(row: any) {
    const {
      addressed,
      campaignNr,
      comments,
      displaySize,
      invoiceRecipient,
      limit,
      marketingFee,
      netting,
      returnableItems,
      storeCount,
      withAd
    } = row.campaignInfo;

    return (
      addressed ||
      campaignNr ||
      comments ||
      displaySize ||
      invoiceRecipient ||
      limit ||
      marketingFee ||
      netting ||
      returnableItems ||
      storeCount ||
      withAd
    );
  }

  public openCampaignDialog(row: any) {
    const readonly = this.readonly || this.isRowDeletedOrRemoved(row);
    this._dialog.open(
      ProductCampaignInfoDialogComponent,
      {
        ...appSettings.DIALOG_SIZES.M,
        data: {
          retailerId: this.retailerId,
          product: row.value,
          readonly: readonly,
          offerKind: OfferKind.SupplierOffer
        }
      },
      (res) => {
        if (!res) {
          return;
        }

        row.get("campaignInfo").setValue(res);
        row.patchValue({
          campaignInfo: res,
          display: res.display
        });
      }
    );
  }

  public getProcurementIcon(row: any) {
    const { procurementDetails } = row.value || {};
    return this.isEmpty(procurementDetails)
      ? "retailer-supplier-prices-info-empty-without-procurement"
      : "retailer-supplier-prices-info-filled-with-procurement";
  }

  public openProcurementDialog(row: any) {
    this._dialog.open(
      OfferProductProcurementDetailDialogComponent,
      {
        ...appSettings.DIALOG_SIZES.M,
        data: {
          product: row.value,
          readonly: this.readonly
        }
      },
      (res) => {
        if (!res) {
          return;
        }

        row.get("procurementDetails").setValue(res);
      }
    );
  }

  public openOrderDialog(row: any) {
    this._dialog.open(
      OfferProductOrderDetailDialogComponent,
      {
        ...appSettings.DIALOG_SIZES.M,
        data: {
          product: row.value,
          readonly: this.readonly
        }
      },
      (res) => {
        if (!res) {
          return;
        }
        row.get("orderDetails").setValue(res);
      }
    );
  }

  public isEmpty(o: any) {
    return (
      o &&
      Object.keys(o)
        .map((x) => o[x])
        .filter((x) => x !== "" && x !== null && x !== undefined).length === 0
    );
  }

  public getPriceChangeIcon(row: any) {
    const { priceChangeNote } = row.value || {};
    return priceChangeNote ? "price-change-filled" : "price-change-empty";
  }

  public openPriceChangeDialog(row: any) {
    this._dialog.open(
      ProductPriceChangesInfoDialogComponent,
      {
        ...appSettings.DIALOG_SIZES.M,
        data: {
          product: row.value,
          readonly: this.readonly
        }
      },
      (res) => {
        if (!res) {
          return;
        }

        row.get("priceChangeNote").setValue(res.note);
      }
    );
  }

  public activeOfferClick(offerId: string) {
    const url = this._router.createUrlTree(["/offers", offerId]).toString();
    window.open(window.location.origin + url, "_blank");
  }

  public getActiveOffer(row: any): any {
    return this._getActiveItem(row, "activeOffers");
  }

  public getActiveCampaignPriceScheme(row: any): any {
    return this._getActiveItem(row, "activeCampaignPriceSchemes");
  }

  public scrollSelectIntoView(e) {
    const productSelectElem = document.getElementById(
      `productSelect-${this.for}`
    );
    productSelectElem?.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  private _getActiveItem(row: any, collectionPropertyName: any): any {
    let items = row.get(collectionPropertyName).value;
    return items?.[0];
  }

  public getProductUrl(row: FormGroup) {
    const { productId } = row?.value || {};
    return this._router.createUrlTree(["/products", productId]).toString();
  }

  public getProductValidationUrl(row: FormGroup) {
    const retailerId = this.formGroup.get("retailer")?.value?.id;
    const { productId } = row?.value;
    return this._router
      .createUrlTree(["/products", productId, "validate"], {
        queryParams: retailerId
          ? {
              retailerId: [retailerId]
            }
          : null
      })
      .toString();
  }

  public get formatCurrencyPrice() {
    const pipe = this._priceValuePipe;
    const currency = this.currency;
    return function (val) {
      return pipe.transform(val, 3, currency?.value);
    };
  }

  // PRODUCT SUSPENSION

  public toggleSuspendProduct(row: FormGroup) {
    const isRowSuspended = row.value.isSuspended;
    row.get("isSuspended").setValue(!isRowSuspended);
  }

  // PRODUCT REPLACEMENT

  sortPredicate(index: number, item: CdkDrag<FormGroup>) {
    const dropList = this as unknown as CdkDropList; // this = CdkDropList
    const sortData = dropList.data.filteredData;

    const itemData = item.data.value;
    const replacementForProductId = itemData.replacementForProductId;

    if (replacementForProductId) {
      const replacementForSameProduct =
        sortData[index]?.value?.replacementForProductId ===
        replacementForProductId;
      if (replacementForSameProduct) {
        return true;
      }
      return false;
    }

    if (index === 0 || index === sortData.length - 1) {
      return true;
    }

    function isReplacementProduct(index) {
      return sortData[index]?.value?.replacementForProductId ? true : false;
    }

    const canBeDropped =
      !isReplacementProduct(index) && !isReplacementProduct(index + 1);
    return canBeDropped;
  }

  private _replaceProduct(replacementProduct: any, targetIndex: number) {
    const replacementItem = this._createRowObject(
      this._getNormalizedItem(replacementProduct, true)
    );
    const insertIndex = targetIndex + 1;
    const insert = this._arr.at(1);
    const insertControl = this._arr.at(insertIndex);
    if (insertControl?.value?.replacementForProductId) {
      insert.patchValue(replacementItem);
    } else {
      this._arr.insert(insertIndex, replacementItem);
    }
    this._updateTable();
    this._bindCalculations();
  }

  public openReplaceProductDialog(row, targetIndex: number) {
    const { productId } = row.value;
    let products = [row];

    if (this.isRowReplaced(row)) {
      const replacementProducts = this.dataSource.data.filter(
        (x) => x.value.replacementForProductId === productId
      );
      products = products.concat(replacementProducts);
    }

    this._dialog.open(
      OfferProductReplacementDialog,
      {
        width: appSettings.DIALOG_WIDTHS.L,
        height: appSettings.DIALOG_WIDTHS.AUTO,
        data: {
          products: products,
          offerId: this.offerId,
          readonly: true,
          retailerId: this.retailerId,
          offerType: this.offerType,
          date: this.date,
          currency: this.currency
        }
      },
      (products) => {
        if (!products) {
          return;
        }

        for (let i = 0; i < products.length; i++) {
          this._replaceProduct(products[i].value, targetIndex + i);
        }
      }
    );
  }

  public showRecentCampaignRowError(row) {
    if (this.offerType === OfferType.Campaign) {
      return row.value.isInRecentCampaign;
    }
    return false;
  }

  public showEndOfLifeRowError(row) {    
    const assortmentStatusValue = row.get('assortmentStatus')?.value;
    return assortmentStatusValue === SupplierProductAssortmentStatus.EndOfLife;
  }

  public rowHasErrors(row) {
    return this.showRecentCampaignRowError(row) || this.isRowInvalid(row.value) || this.showEndOfLifeRowError(row) || this.hasInvalidDeliveryStatus(row.value) || this.isOrderUnitMissing(row) || this.showProductInOtherProcurementItemRowError(row);
  }

  public canReplaceProduct(row) {
    const { replacementForProductId } = row.value;
    return !replacementForProductId && !this.isRowDeletedOrRemoved(row);
  }

  // CAMPAIGN

  public isPercentCampaignType(row) {
    const { campaignType } = row.value;

    if (campaignType == null) {
      return true;
    }

    return row.value.campaignType.valueType == CampaignTypeValueType.Percent;
  }

  public isValueCampaignType(row) {
    return (
      row.value.campaignType?.valueType == CampaignTypeValueType.Value || false
    );
  }

  public onCampaignTypeChange(selectedCampaignType, row: FormGroup) {
    const scheme = this.getValidRetailerProductBuyInPriceScheme(row.value);
    if (!selectedCampaignType || !scheme) {
      return;
    }

    const { numericValue } = selectedCampaignType;
    row.get("discountCampaignWithType").setValue(numericValue);
  }

  public getDiscountCampaignWithType(item: any) {
    const scheme = this.getValidRetailerProductBuyInPriceScheme(item);
    if (!scheme) {
      return null;
    }

    const campaignType = this.campaignTypes?.find(
      (x) => x.id == item.campaignTypeId
    );

    return this._getDiscountCampaignWithType(
      campaignType,
      scheme,
      item.suggestedRetailPrice
    );
  }

  private _getDiscountCampaignWithType(
    campaignType,
    validPrice,
    suggestedRetailPrice
  ) {
    const { vatType, valueType } = campaignType || {};
    const price =
      vatType == CampaignTypeVatType.WithVat
        ? validPrice?.price
        : validPrice?.priceWithoutVat;

    if (!price) {
      return;
    }

    return valueType == CampaignTypeValueType.Value
      ? price - suggestedRetailPrice
      : ((price - suggestedRetailPrice) / price) * 100;
  }

  public hasInvalidDeliveryStatus(row) {
    return (!this.offerStatus || this.offerStatus == SupplierOfferStatus.Created) &&
      row.assortmentDeliveryStatus == SupplierProductAssortmentDeliveryStatus.StopSales;
  }
}

export const SupplierOfferProductDefaultItem = {
  productId: null,
  preview: {},
  campaignInfo: {},
  name: null,
  display: false,
  productHasDisplay: false,
  limit: null,
  ean: null,
  supplierCode: null,
  brand: null,
  availableFrom: null,
  campaignPriceValidFrom: null,
  selfPrice: null,
  calculatedSelfPriceInForeignCurrency: null,
  listPrice: null,
  vat: null,
  mainAssortmentPrice: null,
  mainAssortmentListPrice: null,
  mainAssortmentCurrency: null,
  salePrice: null,
  salePriceCampaign: null,
  discount: null,
  discountCampaign: null,
  suggestedRetailPrice: null,
  shops: [],
  assortmentStatus: null,
  imageUrl: null,
  thumbnailUrl: null,
  thumbnail: null,
  thumbnailContentType: null,
  contentUnitId: null,
  netContent: null,
  drainedWeightInGrams: null,
  validSchemeSelfPrice: null,
  validSchemeCalculatedSelfPriceInForeignCurrency: null,
  validSchemeListPrice: null,
  validSchemeMainAssortmentPrice: null,
  validSchemeMainAssortmentListPrice: null,
  requestedPrice: null,
  segment: null,
  storageConditions: null,
  storageMinTemp: null,
  storageMaxTemp: null,
  transportUnitDefaultEan: null,
  palletType: null,
  status: OfferProductStatus.Pending,
  isDeleted: false,
  isNew: true,
  isValid: true,
  isSuspended: false,
  isOrderUnitMissing: false,
  isInOtherProcurementItem: false,
  replacementForProductId: null
};
